// 3 modlu giris ekrani — StatsCard pattern'iyle uyumlu kart iskeletleri.
// borderRadius 16, ince gri border, 1-2px shadow, hover yumusak translate
// + shadow. Icon box 42x42, gradient soft palette, StatsCard iconBox eşi.

import { Card, CardContent, Box, Typography } from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import GroupIcon from '@mui/icons-material/Group';
import PersonIcon from '@mui/icons-material/Person';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

// StatsCard palette'iyle birebir — primary / info / secondary (purple)
const MODES = [
  {
    key: 'teams',
    title: 'Ekipler Arası',
    description: 'Birden fazla ekip seç, iş dağılımlarını yan yana karşılaştır.',
    icon: GroupsIcon,
    fg: '#3a5af0', soft: 'rgba(58,90,240,0.12)',
  },
  {
    key: 'members',
    title: 'Ekip İçi',
    description: 'Bir ekibi seç, üyelerin iş yükünü kişi kişi karşılaştır.',
    icon: GroupIcon,
    fg: '#0ea5e9', soft: 'rgba(14,165,233,0.12)',
  },
  {
    key: 'people',
    title: 'Kişi Bazlı',
    description: 'İstediğin kişileri seç, iş dağılımlarını karşılaştır.',
    icon: PersonIcon,
    fg: '#7c5cf0', soft: 'rgba(124,92,240,0.12)',
  },
];

const ModeSelector = ({ onSelect }) => (
  <Box sx={{
    display: 'grid', gap: 2.5,
    gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' },
    mt: 1,
  }}>
    {MODES.map((m) => (
      <Card
        key={m.key}
        elevation={0}
        onClick={() => onSelect(m.key)}
        sx={{
          height: '100%',
          borderRadius: '16px',
          background: '#ffffff',
          border: '1px solid #e8eaee',
          boxShadow: '0 1px 2px rgba(20,30,55,.04)',
          cursor: 'pointer',
          transition: 'border-color 0.15s ease',
          overflow: 'hidden',
          position: 'relative',
          '&:hover': {
            borderColor: m.fg,
            '& .mode-arrow': { transform: 'translateX(3px)', color: m.fg, opacity: 1 },
          },
        }}
      >
        <CardContent sx={{
          p: '24px !important',
          '&:last-child': { pb: '24px !important' },
          display: 'flex', flexDirection: 'column', gap: 1.5,
        }}>
          {/* Icon box — StatsCard iconBox pattern */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <Box sx={{
              width: 42, height: 42, borderRadius: '12px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: `linear-gradient(135deg, ${m.soft}, ${m.soft.replace(/0\.\d+\)$/, '0.04)')})`,
              border: `1px solid ${m.soft}`,
              color: m.fg,
              flexShrink: 0,
            }}>
              <m.icon sx={{ fontSize: '1.35rem' }} />
            </Box>

            <ArrowForwardIcon className="mode-arrow" sx={{
              fontSize: 18, color: '#c8ccd4', opacity: 0.6,
              transition: 'transform 0.2s ease, color 0.2s ease, opacity 0.2s ease',
            }} />
          </Box>

          <Typography sx={{
            fontSize: '17px', fontWeight: 800, color: '#0f1424',
            letterSpacing: '-0.3px', lineHeight: 1.2,
          }}>
            {m.title}
          </Typography>
          <Typography sx={{
            fontSize: '13px', fontWeight: 500, color: '#626b78',
            lineHeight: 1.5,
          }}>
            {m.description}
          </Typography>
        </CardContent>
      </Card>
    ))}
  </Box>
);

export default ModeSelector;
